import { apiClient } from './apiClient';

export interface AIConfiguration {
  id: number;
  platform: string;
  model: string;
  is_active: boolean;
  config?: any;
  created_at: string;
  updated_at: string;
}

export interface CreateAIConfigurationData {
  platform: string;
  model: string;
  api_key: string;
  is_active?: boolean;
  config?: any;
}

export interface UpdateAIConfigurationData {
  platform?: string;
  model?: string;
  api_key?: string;
  is_active?: boolean;
  config?: any;
}

export interface PlatformInfo {
  name: string;
  models: string[];
}

export interface AIConfigurationResponse {
  success: boolean;
  data: {
    configurations: AIConfiguration[];
    platforms: Record<string, PlatformInfo>;
  };
  message?: string;
}

class AIConfigurationService {
  /**
   * Get all AI configurations and available platforms
   */
  async getConfigurations(): Promise<AIConfigurationResponse> {
    const response = await apiClient.get('/ai-configurations');
    return response.data;
  }

  /**
   * Create a new AI configuration
   */
  async createConfiguration(data: CreateAIConfigurationData): Promise<any> {
    const response = await apiClient.post('/ai-configurations', data);
    return response.data;
  }

  /**
   * Update an AI configuration
   */
  async updateConfiguration(id: number, data: UpdateAIConfigurationData): Promise<any> {
    const response = await apiClient.put(`/ai-configurations/${id}`, data);
    return response.data;
  }

  /**
   * Delete an AI configuration
   */
  async deleteConfiguration(id: number): Promise<any> {
    const response = await apiClient.delete(`/ai-configurations/${id}`);
    return response.data;
  }

  /**
   * Activate an AI configuration
   */
  async activateConfiguration(id: number): Promise<any> {
    const response = await apiClient.post(`/ai-configurations/${id}/activate`);
    return response.data;
  }

  /**
   * Get active configuration for a platform
   */
  async getActiveConfiguration(platform: string): Promise<any> {
    const response = await apiClient.get(`/ai-configurations/${platform}/active`);
    return response.data;
  }
}

export default new AIConfigurationService(); 